import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Feather, Menu } from "react-feather";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import { addContractorCount } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import FeatherIcon from "feather-icons-react";
import Accordion from "react-bootstrap/Accordion";
import { ADANI_TRI_COLOR_PALATE } from "../../constants/common";
import {
  ACC_COLOR_PALATE,
  AMBUJA_COLOR_PALATE,
  DARPAN_COLOR_PALATE,
  ADANI_COLOR_PALATE,
} from "../../constants/common";
import { serverAssets } from "../../constants/common";
import { addUserData } from "../../redux/slices/userTypeSlice.js";

const CircularSlider = () => {
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;
  const userData =  useSelector(
      state => state.userTypeSlice.userData,
  );

  const [imgUrl, setImageUrl] = useState("");

  useEffect(() => {
    if (userData?.tierName) {
      setImageUrl(`${userData.tierName}_Speedometer.png`);
    }
  }, [brandId, userData]);

  return (
    <div>
      {imgUrl !== "" && (
        <img
          src={`${serverAssets}/${imgUrl}`} 
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      )}
    </div>
  );
};

export default CircularSlider;
